<!-- TelaExtraiDadosUsuario.svelte -->
<script>
  import ExtraiDadosBasico from "../../Componentes/ExtracaoDados/ExtraiDadosBasico.svelte";
  import ExibeItem from "../../Classes/exibeItem.js";
  import BotaoInserir from "../../componentes_basicos/BotaoInserir.svelte";
    import Pesquisa from "../../Componentes/ExtracaoDados/Pesquisa.svelte";
    import Constantes from "../../Classes/Constantes";
  
    
  
 
  let termo_pesquisa;
  let componente;
  let camponente_pesquisar="";
  const api = "consultas.php";
  const parametros = {
   
    query_code: "consulta_generica_livre_paginada_filtrada",
    tabela: "tamanhos_camisa_view",
    termo_pesquisa: termo_pesquisa,
    campos_pesquisaveis: ["tamanho_roupa"],
    
  };
  const celulas = [
    new ExibeItem("Tamanho", "tamanho_roupa"),
    new ExibeItem("Campeonato", "nome_campeonato"),

    
  ];

  //só precisa configurar acima disto
</script>
<div class="centralizar">
        
<Pesquisa bind:value={termo_pesquisa} {parametros} extraiDadosBasico={componente}  {termo_pesquisa} >


<ExtraiDadosBasico bind:this = {componente} {api} {parametros} {celulas} navegacao={Constantes.tela_editar_camisas} />


</Pesquisa>
<BotaoInserir navegarPara={Constantes.tela_editar_camisas} />

</div>

<style>
  .centralizar {
    margin-top: 20px;
    margin-bottom: 100px;
  
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
  }
</style>
  